const constants = {
  BUSINESSID: "x-businessId",
};

export default constants;
